import React from 'react'
import GenericIcon from 'components/GenericIcon'
import PersonalService from "website/about-us/personal-service.png"
import TickWithinCircle from "website/about-us/tick-within-circle.svg"

const OurMission = () => (
  <div className='our-mission-container mt-5'>
    <div className='container'>
      <div className="row our-mission-body">
        <div className="col-md-4 col-sm-12 our-mission-text-body">
          <h3>Our mission</h3>
          <div className="mt-4 mb-4"> Help Australians build wealth and we do this by offering:</div>
          <div className='d-flex mt-4 mb-4'>
            <TickWithinCircle /><b className='our-mission-text ml-3'>Low rates and fees</b>
          </div>
          <div className='d-flex mt-4 mb-4'>
            <TickWithinCircle /><b className='our-mission-text ml-3'>Fully-featured loans</b>
          </div>
          <div className='d-flex mt-4 mb-4'>
            <TickWithinCircle /><b className='our-mission-text ml-3'>Tailored personal service</b>
          </div>
          <div className='d-flex mt-4 mb-4'>
            <TickWithinCircle /><b className='our-mission-text ml-3'>A digital home loan experience</b>
          </div>
          <div className='mt-5'>
            We can help people with a wide range of individual financial
            circumstances, who are looking for loans for residential
            homes across Australia.
          </div>
        </div>
        <div className="our-mission-image-container" >
          <div className="our-mission-image" />
        </div>
      </div>
    </div>
  </div>
);

export default OurMission
